import BoringAvatar from "boring-avatars";
export const Avatar = ({
  name,
  size = 32
}: {
  name: string;
  size?: number;
}) => {
  return <BoringAvatar size={size} name={name} variant="marble" data-sentry-element="BoringAvatar" data-sentry-component="Avatar" data-sentry-source-file="Avatar.tsx" />;
};